import { ProjectItem } from "./ProjectItem";

export function generateBillingItem(
  project: string,
  activity: string,
  part_number: string,
  product_name: string,
  quantity: number,
  unit_price: number,
  total_price: number,
  totalAmountWithVat: number,
  currency: string,
  vatValue: string,
  purchasePrice: string,
  u_item: ProjectItem = {},
): ProjectItem {
  let item: ProjectItem = {
    ...u_item,
    project: "" + project,
    activity: "" + activity,
    item: part_number,
    amount: "" + unit_price,
    catalogPrice: "" + unit_price,
    totalQuantity: "" + quantity,
    quantity: "" + quantity,
    currency: currency,
    purchaseCurrency: currency,
    totalAmount: "" + total_price,
    totalAmountWithVat: "" + totalAmountWithVat,
    name: product_name,
    vatValue: "" + vatValue,
    purchasePrice: purchasePrice,
    billingStatus: "1",
  };
  return item;
}

export function generateProjectProductItem(
  folder: string,
  project: string,
  activity: string,
  part_number: string,
  product_name: string,
  quantity: number,
  unit_price: number,
  total_price: number,
  totalAmountWithVat: number,
  currency: string,
  vatValue: string,
  purchasePrice: string,
  attrib0: string,
  attrib0_id: string,
  attrib1: string,
  attrib1_id: string,
  attrib2: string,
  attrib2_id: string,
  attrib3: string,
  attrib3_id: string,
  attrib4: string,
  attrib4_id: string,
  attrib5: string,
  attrib5_id: string,
  attrib6: string,
  attrib6_id: string,
  attrib7: string,
  attrib7_id: string,
  attrib8: string,
  attrib8_id: string,
  attrib9: string,
  attrib9_id: string,
  supplier: string,
  refId: string,
  billingDate: string,
  billingStatus: string,
  parentId?: string,
  u_item: ProjectItem = {},
): ProjectItem {
  let item: ProjectItem = {
    ...u_item,
    folder: "" + folder,
    project: "" + project,
    activity: "" + activity,
    item: part_number,
    amount: "" + unit_price,
    catalogPrice: "" + unit_price,
    totalQuantity: "" + quantity,
    quantity: "" + quantity,
    currency: currency,
    purchaseCurrency: currency,
    totalAmount: "" + total_price,
    totalAmountWithVat: "" + totalAmountWithVat,
    name: product_name,
    vatValue: "" + vatValue,
    purchasePrice: purchasePrice,
    billingStatus: "" + billingStatus,
    attrib0,
    attrib0_id,
    attrib1,
    attrib1_id,
    attrib2,
    attrib2_id,
    attrib3,
    attrib3_id,
    attrib4,
    attrib4_id,
    attrib5,
    attrib5_id,
    attrib6,
    attrib6_id,
    attrib7,
    attrib7_id,
    attrib8,
    attrib8_id,
    attrib9,
    attrib9_id,
    supplier,
    refId,
    billingDate,
    parentId,
  };
  return item;
}

export function createProjectProductItem(
  folder?: string,
  project?: string,
  activity?: string,
  part_number?: string,
  product_name?: string,
  quantity?: string,
  unit_price?: string,
  total_price?: string,
  totalAmountWithVat?: string,
  currency?: string,
  vatValue?: string,
  purchasePrice?: string,
  attrib0?: string,
  attrib0_id?: string,
  attrib1?: string,
  attrib1_id?: string,
  attrib2?: string,
  attrib2_id?: string,
  attrib3?: string,
  attrib3_id?: string,
  attrib4?: string,
  attrib4_id?: string,
  attrib5?: string,
  attrib5_id?: string,
  attrib6?: string,
  attrib6_id?: string,
  attrib7?: string,
  attrib7_id?: string,
  attrib8?: string,
  attrib8_id?: string,
  attrib9?: string,
  attrib9_id?: string,
  supplier?: string,
  refId?: string,
  billingDate?: string,
  billingStatus?: string,
  parentId?: string,
  itemSerial?: string,
  u_item: ProjectItem = {},
): ProjectItem {
  let item: ProjectItem = {
    ...u_item,
    folder: folder,
    project: project,
    activity: activity,
    item: part_number,
    amount: unit_price,
    catalogPrice: unit_price,
    totalQuantity: quantity,
    quantity: quantity,
    currency: currency,
    purchaseCurrency: currency,
    totalAmount: total_price,
    totalAmountWithVat: totalAmountWithVat,
    name: product_name,
    vatValue: vatValue,
    purchasePrice: purchasePrice,
    billingStatus: billingStatus,
    attrib0,
    attrib0_id,
    attrib1,
    attrib1_id,
    attrib2,
    attrib2_id,
    attrib3,
    attrib3_id,
    attrib4,
    attrib4_id,
    attrib5,
    attrib5_id,
    attrib6,
    attrib6_id,
    attrib7,
    attrib7_id,
    attrib8,
    attrib8_id,
    attrib9,
    attrib9_id,
    supplier,
    refId,
    billingDate,
    parentId,
    itemSerial,
  };
  return item;
}
